@if (solutionSpace$ | async; as solutionSpace) {
<app-component-incidents
  [solutionSpace]="solutionSpace"
  [updateIncidentsReponse$]="updateIncidentsResponse$"
  [incidents$]="incidents$"
  (changeIncidentsFilter)="onChangeIncidentsFilter($event)"
  (changePagination)="onChangePagination($event)"
  (updateIncidents)="onUpdateIncidents($event)"
>
</app-component-incidents>
}
